module.exports = __webpack_public_path__ + "static/media/btc.630fff17.svg";